import { Controller } from "@hotwired/stimulus";
import { visitTrail } from "../visit_trail.js";

export default class extends Controller {
  static targets = ["originPage", "landingPage", "externalReferrer", "projectType", "hint"];
  static values = { projectTypes: Object, hints: Object };

  connect() {
    const ref = new URLSearchParams(location.search).get("ref");
    const projectType = this.projectTypesValue[ref];
    if (projectType && !this.projectTypeTarget.value) this.projectTypeTarget.value = projectType;
    this.updateHint();
  }

  offer() {
    const selected = this.projectTypeTarget.value;
    for (const [ref, offer] of [["ai-audit", "audit"], ["ai-integration", "integration"], ["ai-training", "training"], ["custom-software-brittany", "custom-software"]]) {
      if (selected && selected === this.projectTypesValue[ref]) return offer;
    }
    return "other";
  }

  updateHint() {
    this.hintTarget.textContent = this.hintsValue[this.offer()] || this.hintsValue.other;
  }

  fill() {
    const trail = visitTrail();
    const ref = new URLSearchParams(location.search).get("ref");
    const origin = trail.previous || "(direct)";
    this.originPageTarget.value = ref ? `${origin} (ref=${ref})` : origin;
    this.landingPageTarget.value = trail.landing || "";
    this.externalReferrerTarget.value = trail.referrer || "";
  }

}
